import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { OrganizationsService } from '../../services/organizations.service';
import { PermissionsService } from '../../services/permissions.service';
import { NotificationService } from '../../services/notification.service';

@Component({
    selector: 'app-create-organization',
    imports: [
        MatButtonModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule
    ],
    templateUrl: './create-organization.component.html',
    styleUrl: './create-organization.component.css'
})
export class CreateOrganizationComponent {

  createForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    address: new FormControl(''),
    NIP: new FormControl(''),
  });

  constructor(
    public router: Router,
    public permissionsService: PermissionsService,
    public organizationsService: OrganizationsService,
    private notificationService: NotificationService,

  ) {
  } 

  onSubmit() {
    console.log(this.createForm.value);

    if (this.createForm.valid) {
      this.organizationsService.createOrganization(this.createForm.value)
      .subscribe({
        next: (response: any) => {
          console.log(response);

          this.notificationService.pushNotification(
            `Organizacja została dodana`, 'info', 5000);

          this.router.navigate(['/organizations-list']);
        },
        error: (error) => {
          console.log(error);
          if (error.status === 401) {
            this.router.navigate(['/login']);
          }
        }
      });
    }
  } 

}
